<script>
import { mapGetters } from "vuex";
import Spinner from "@/components/ui/Spinner";
import InstitutionList from "@/components/settings/institution/InstitutionList";
import MedicalSpecialtyList from "@/components/settings/medicalSpecialty/MedicalSpecialtyList";
import LabelList from "@/components/settings/label/LabelList";
import CommissionList from "./commission/CommissionList";
import MedicalInsuranceList from "@/components/settings/medicalInsurance/MedicalInsuranceList";
import BaseSubNav from "@/components/ui/BaseSubNav.vue";
import ProgramList from "@/components/settings/program/ProgramList.vue";
import MedicalPracticeList from "@/components/settings/medicalPractice/MedicalPracticeList.vue";
import LabList from "@/components/settings/lab/LabList.vue";
import { isProgramsEnabled } from "@/services/config";

export default {
  name: "SettingsDashboard",

  components: {
    Spinner,
    InstitutionList,
    LabelList,
    MedicalSpecialtyList,
    CommissionList,
    MedicalInsuranceList,
    ProgramList,
    MedicalPracticeList,
    LabList,
    BaseSubNav,
  },

  data() {
    return {
      category: "locations",
      isProgramsEnabled,
    };
  },

  computed: {
    ...mapGetters(["isAdmin"]),
  },

  methods: {
    getClassName(type) {
      const className = `${type}-color`;

      if (this.category === type) {
        return `${className} is-active`;
      } else {
        return className;
      }
    },

    setCategory(category) {
      this.category = category;
    },
  },
};
</script>

<template lang="pug">
section.treatment-tasks
  BaseSubNav(
    navigation-type="settings"
    :show-navigation="true"
  )
    template(#title)
      h1 Configuración
  article.row
    nav.sidebar
      a.sidebar__link(v-if="isAdmin" @click="setCategory('locations')", :class="getClassName('locations')")
        micon(name="institution")
        strong.sidebar__text Instituciones
      a.sidebar__link(v-if="isAdmin" @click="setCategory('medical-specialty')", :class="getClassName('medical-specialty')")
        micon(name="medical-specialty")
        strong.sidebar__text Especialidades
      a.sidebar__link(v-if="isAdmin" @click="setCategory('labels')", :class="getClassName('labels')")
        micon(name="label")
        strong.sidebar__text Etiquetas
      a.sidebar__link(v-if="isAdmin" @click="setCategory('commissions')", :class="getClassName('commissions')")
        micon(name="label")
        strong.sidebar__text Comisiones
      a.sidebar__link(v-if="isAdmin" @click="setCategory('medical-insurance')", :class="getClassName('medical-insurance')")
        micon(name="label")
        strong.sidebar__text Seguros médicos
      a.sidebar__link(v-if="isAdmin && isProgramsEnabled" @click="setCategory('programs')", :class="getClassName('programs')")
        micon(name="label")
        strong.sidebar__text Programas
      a.sidebar__link(v-if="isAdmin" @click="setCategory('medical-practices')", :class="getClassName('medical-practices')")
        micon(name="label")
        strong.sidebar__text Prácticas
      a.sidebar__link(v-if="isAdmin" @click="setCategory('labs')", :class="getClassName('labs')")
        micon(name="label")
        strong.sidebar__text Laboratorios

    .box.box--full.box--with-subnav
      .content
        .data
          InstitutionList(v-if="isAdmin && category==='locations'")
          MedicalSpecialtyList(v-if="isAdmin && category==='medical-specialty'")
          LabelList(v-if="isAdmin && category==='labels'")
          CommissionList(v-if="isAdmin && category==='commissions'")
          MedicalInsuranceList(v-if="isAdmin && category==='medical-insurance'")
          ProgramList(v-if="isAdmin && isProgramsEnabled && category==='programs'")
          MedicalPracticeList(v-if="isAdmin && category==='medical-practices'")
          LabList(v-if="isAdmin && category==='labs'")
</template>

<style lang="scss" scoped>
.treatment-tasks {
  .title {
    margin: auto 5px;
  }

  .sidebar {
    box-shadow: -5px 0px 5px 0 rgba(0, 0, 0, 0.1);
    padding-right: 0;
    z-index: 999;
    .sidebar__link {
      &.is-active {
        /* background-color: $primary; */
        background-color: white;
        outline: 0 5px 0 0 solid white;

        .sidebar__text {
          color: $primary;
        }

        svg {
          fill: $primary;
        }
      }
    }
  }

  .content {
    display: flex;
    flex-wrap: wrap;
    padding: 20px 50px;

    .data {
      width: 100%;
    }
  }

  .vitals-color {
    .micon {
      fill: $vital;
    }
  }
  .checkins-color {
    .micon {
      fill: $checkin;
    }
  }
  .medications-color {
    .micon {
      fill: $medication;
    }
  }
  .appointments-color {
    .micon {
      fill: $appointment;
    }
  }
  .recommendations-color {
    .micon {
      fill: $recommendation;
    }
  }
  .exercises-color {
    .micon {
      fill: $exercise;
    }
  }
  .reports-color {
    .micon {
      fill: $report;
    }
  }

  .box.box--full.box--with-subnav {
    min-height: 82vh;
  }
}
</style>
